module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/my_catalog_order_index-d90459dfbd7c60da6c9b933890a29f50.png";